import React from 'react';
import Tooltip from '../Tooltip';
import defaultCursor from '../../images/defaultCursor.svg';
import trashIcon from '../../images/trashIcon.svg';
import linkIcon from '../../images/linkIcon.svg';

/**
 * Sélecteur de mode de curseur
 */
export default function CursorModeSelector({ cursorMode, setCursorMode, selectedSkillId, skills }) {
  return (
    <div
      style={{
        position: 'absolute',
        left: '50%',
        top: '50%',
        transform: 'translate(-50%, -50%)',
        display: 'flex',
        border: '1px solid #ccc',
        borderRadius: '9px',
        overflow: 'hidden',
        backgroundColor: '#fff',
      }}
    >
      {/* Curseur "normal" */}
      <Tooltip text="Edition des positions/danseurs (A)">
        <div
          onClick={() => setCursorMode('default')}
          style={{
            padding: '4px 8px',
            backgroundColor: cursorMode === 'default' ? '#ddd' : '#fff',
            cursor: 'pointer',
            borderRight: '1px solid #ccc',
            userSelect: 'none',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: '15px',
            flexShrink: 0,
          }}
        >
          <img 
            src={defaultCursor} 
            alt="Default Cursor" 
            style={{ width: '20px', height: '20px' }} 
          />
        </div>
      </Tooltip>

      {/* Curseur rond gris */}
      <Tooltip text="Ajouter une position par clic (P)">
        <div
          onClick={() => setCursorMode('circle')}
          style={{
            padding: '4px 8px',
            backgroundColor: cursorMode === 'circle' ? '#ddd' : '#fff',
            cursor: 'pointer',
            borderRight: '1px solid #ccc',
            userSelect: 'none',
            width: '15px',
            flexShrink: 0,
          }}
        >
          <span style={{ fontSize: '17px', color: 'gray' }}>●</span>
        </div>
      </Tooltip>

      {/* Curseur étoile */}
      <Tooltip text="Assigner le skill sélectionné aux positions/danseurs cliqués (S)">
        <div
          onClick={() => setCursorMode('star')}
          style={{
            padding: '4px 8px',
            backgroundColor: cursorMode === 'star' ? '#ddd' : '#fff',
            cursor: 'pointer',
            borderRight: '1px solid #ccc',
            userSelect: 'none',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: '15px',
            flexShrink: 0,
          }}
        >
          {selectedSkillId ? (
            <span
              style={{
                color: (skills.find((sk) => sk.id === selectedSkillId)?.color) || '#000',
              }}
            >
              ★
            </span>
          ) : (
            <span style={{ color: '#666' }}>★</span>
          )}
        </div>
      </Tooltip>

      {/* Curseur lien */}
      <Tooltip text="Lier des positions entre périodes différentes (L)">
        <div
          onClick={() => setCursorMode('link')}
          style={{
            padding: '4px 8px',
            backgroundColor: cursorMode === 'link' ? '#ddd' : '#fff',
            cursor: 'pointer',
            borderRight: '1px solid #ccc',
            userSelect: 'none',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: '15px',
            flexShrink: 0,
          }}
        >
          <img 
            src={linkIcon} 
            alt="Link Cursor" 
            style={{ width: '20px', height: '20px' }} 
          />
        </div>
      </Tooltip>

      {/* Curseur poubelle */}
      <Tooltip text="Supprimer les positions/danseurs cliqués (K)">
        <div
          onClick={() => setCursorMode('trash')}
          style={{
            padding: '4px 8px',
            backgroundColor: cursorMode === 'trash' ? '#FFCCD5' : '#fff',
            cursor: 'pointer',
            userSelect: 'none',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: '15px',
            flexShrink: 0,
          }}
        >
          <img 
            src={trashIcon} 
            alt="Trash Cursor" 
            style={{ width: '20px', height: '20px' }} 
          />
        </div>
      </Tooltip>
    </div>
  );
}
